'use client';

import { useSearchParams } from 'next/navigation';
import { Suspense, useEffect } from 'react';
import { useTypedDispatch, useTypedSelector } from '@/redux/helpers/hooks.ts';
import { bulkSearchDomains } from '@/redux/slices/domains/thunks/bulkSearchDomains.ts';
import DomainNameCustomSearchResults, {
  DomainNameCustomSearchResultsProps,
} from '@template/blocks/domain/DomainNameCustomSearchResults';

const DomainNameBulkSearchResults = ({
  ...props
}: Omit<DomainNameCustomSearchResultsProps, 'results' | 'loading'>) => {
  const dispatch = useTypedDispatch();
  const searchParams = useSearchParams();

  const { results, loading } = useTypedSelector((state) => state.domains.bulk);

  const searchValue = searchParams.get('search');

  useEffect(() => {
    if (searchValue) {
      dispatch(bulkSearchDomains({ search: searchValue }));
    }
  }, [searchValue]);

  return (
    <DomainNameCustomSearchResults
      results={results}
      loading={loading}
      hidePrimary
      {...props}
    />
  );
};

export default (props) => (
  <Suspense>
    <DomainNameBulkSearchResults {...props} />
  </Suspense>
);
